<template>
  <div class="onboarding-signup-step-description">
    <form @submit.prevent="onSubmit">
      <transition appear :enter-active-class="transition.classes.enter" :leave-active-class="transition.classes.leave">
        <QPage padding>
          <h2 class="step-title-optional">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.INFO.DESCRIPTION.@TITLE")) }}
            <ExtraTag :label="$t('ETAB.BUTTONS.@OPTIONAL')" />
          </h2>

          <QInput
            v-model.trim="form.description"
            stack-label
            :maxlength="XLONG_TEXT_LENGTH_LIMIT"
            type="textarea"
            counter
            :placeholder="$t('ETAB.FORMS.PLACEHOLDERS.@DESCRIPTION')"
          />

          <ExtraTipbox>
            <span>{{ $t("ETAB.PAGES.SIGNUP.STEPS.INFO.DESCRIPTION.@NOTICE") }}</span>
          </ExtraTipbox>
        </QPage>
      </transition>

      <QFooter>
        <div>
          <QBtn color="secondary" type="submit" class="full-width btn-navigation" :label="$t('ETAB.BUTTONS.@NEXT')" no-caps :disabled="!isValid()" />
        </div>
      </QFooter>
    </form>
  </div>
</template>

<script setup>
  import { ACTION_SIGNUP_UPDATE, GETTER_SIGNUP_GET } from "@etab/stores/types";
  import { useSignupStore } from "@etab/stores/signup";
  import { XLONG_TEXT_LENGTH_LIMIT, FIREBASE_EVENTS } from "@core/constants";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { onMounted, ref } from "vue";
  import { useTransition } from "@core/composables";
  import { ISignup } from "@core/models";
  import { useSignup } from "@etab/composables";

  const { transition } = useTransition();
  const { $_nextStep } = useSignup();
  const signupStore = useSignupStore();

  const form = ref({ description: "" });

  const onSubmit = async function () {
    const signupStore = useSignupStore();
    if (isValid()) {
      TrackingManager.addEvent({
        event: FIREBASE_EVENTS.FUNNEL_SECOND_STEP,
        step: "step3_description",
      });
      signupStore[ACTION_SIGNUP_UPDATE]({ [ISignup.description]: form.value.description });
      $_nextStep();
    }
  };

  const isValid = function () {
    return form.value.description.length <= XLONG_TEXT_LENGTH_LIMIT;
  };

  onMounted(() => {
    form.value.description = signupStore[GETTER_SIGNUP_GET][ISignup.description] || "";
  });
</script>

<style lang="scss">
  .onboarding-signup-step-description {
    .extra-tipbox {
      margin-top: 50px;
    }
  }
</style>
